import { MemberStatusEnum } from '../../Enum/MemberStatusEnum';

export default interface IOnboardingCallReport {
    startDateTime: Date;
    endDateTime: Date;
    MemberStatuses: MemberStatusEnum[];
    selectedHealthPlan: string;
    selectedPopulation: number;
    selectedNoteType: string[];
    selectedOnboarder: string;
}

export class OnboardingCallReport implements IOnboardingCallReport {
    startDateTime: Date;
    endDateTime: Date;
    selectedHealthPlan: string;
    selectedPopulation: number | null;
    MemberStatuses: MemberStatusEnum[];
    selectedNoteType: string[];
    selectedOnboarder: string;

    constructor() {
        this.startDateTime = new Date();
        this.endDateTime = new Date();
        this.selectedHealthPlan = '';
        this.selectedPopulation = null;
        this.MemberStatuses = [MemberStatusEnum.Undetermined];
        this.selectedNoteType = [];
        this.selectedOnboarder = '';
    }
}
